import MainSalaDePrensa from "../components/sala-de-prensa/MainSalaDePrensa";

function SalaDePrensa() {
  return <MainSalaDePrensa />;
}

export default SalaDePrensa;
